<template>
  <section class="etc-center">
    <header class="card">
      <div class="card-content" :class="{'danger': userInfo.filter_status!=='0' && userInfo.filter_status!=='6'}">
        <p class="card-name">{{userInfo.issuer_name}}</p>
        <p class="plate-no">{{userInfo.plate_no}}</p>
        <p class="tip">一般通行后3个工作日内扣款</p>
        <img src="../../assets/user/center-card-bg.png" alt="">
      </div>
    </header>
    <div class="err-tip" v-if="userInfo.filter_status!=='0' && userInfo.filter_status!=='6'">卡片出现了小情况，请前往微信“ETC助手”小程序查看详情</div>
    <div class="through-rec">
      <header>
        <span>最新记录</span>
        <span class="all" @click="tapAll">全部记录 <i class="iconfont etc-icon-arrow-right"></i></span>
      </header>
      <ul v-if="loadStatus && throughRec.length">
        <li v-for="(item, index) in throughRec" :key="index">
          <div class="info">
            <p class="location"><span class="dot"><i class="iconfont etc-icon-dot"></i></span><span class="text">{{item.entry_station}}</span></p>
            <p class="time"><span class="dot"><i class="iconfont etc-icon-dot"></i><br><i class="iconfont etc-icon-dot"></i></span><span class="text">{{item.entry_time || '-'}}</span></p>
            <p class="location"><span class="dot"><i class="iconfont etc-icon-dot"></i></span><span class="text">{{item.exit_station || '-'}}</span></p>
            <p class="time"><span class="dot"></span><span class="text">{{item.exit_time || '-'}}</span></p>
          </div>
          <div class="num">
            <span>-{{item.actual_fee}}</span>
          </div>
        </li>
      </ul>
      <div v-if="loadStatus && !throughRec.length" class="no-data">
        暂无通行记录
      </div>
    </div>
    <div class="bottom">
      更多功能，请关注微信“ETC助手”小程序
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// store
import {mapState} from 'vuex'
// api
// import UserApi from '@/api/user.api'

export default {
  name: 'center',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      loadStatus: false,
      throughRec: []
    }
  },
  computed: {
    ...mapState([
    ])
  },
  methods: {
    tapAll() {
      this.m_showConfirm({content: '更多功能，请关注微信“ETC助手”小程序'})
    }
  },
  created() {
    // UserApi.getThroughRec({id: this.userInfo.card_id, page: 1, orderBy: 1}).then(res => {
    //   this.loadStatus = true
    //   if (res.records.success) {
    //     let result = []
    //     if (res.records.success instanceof Object) {
    //       if (res.records.success instanceof Array) {
    //         result = res.records.success
    //       } else {
    //         for (let k in res.records.success) {
    //           result = result.concat(res.records.success[k])
    //         }
    //       }
    //     }
    //     this.throughRec = result.slice(0, 3)
    //   }
    // })
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.etc-center{
  .card{
    height: 530px;
    background: url("../../assets/user/center-bg.png") no-repeat;
    background-size: 100% auto;
    padding-top: 150px;
    .card-content{
      color: #FFFFFF;
      box-shadow: 0 6px 12px 0 rgba(12,161,147,0.34);
      background-image: linear-gradient(-89deg, #4EB355 0%, #0D9D70 100%);
      width: 710px;
      height: 365px;
      padding: 50px;
      margin: 0 auto;
      border-radius: 10px;
      position: relative;
      .card-name{
        font-size: 32px;
        height: 45px;
        line-height: 45px;
      }
      .plate-no{
        font-size: 50px;
        margin-top: 10px;
        height: 70px;
        line-height: 70px;
      }
      .tip{
        font-size: 24px;
        margin-top: 40px;
      }
      img{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      &.danger {
        box-shadow: 0 6px 12px 0 rgba(190,73,0,0.34);
        background-image: linear-gradient(-90deg, #FF9431 0%, #F74D1C 100%);
      }
    }
  }
  .err-tip{
    background: rgba(244,193,44,0.08);
    border-radius: 6px;
    margin: 20px 30px 0;
    padding: 20px 10px;
    /*padding-left: 10px;*/
    font-weight: bold;
    font-size: 24px;
    color: #F94E36;
  }
  .through-rec{
    padding: 0 0 90px 40px;
    header{
      height: 100px;
      border-bottom: 1px solid $border-bottom-color;
      @extend %flex-space-between;
      span:first-child{
        font-size: 32px;
        color: #999999;
      }
      .all{
        font-size: 26px;
        color: #333333;
        padding-right: 40px;
        i{
          color: #dddddd;
          font-size: 26px;
          margin-left: 10px;
        }
      }
    }
    ul{
      li{
        padding: 30px 40px 0 0;
        border-bottom: 1px solid $border-bottom-color;
        @extend %flex-space-between;
        .info{
          flex: 1;
          margin-left: -10px;
          .text{
            line-height: 1;
          }
          .dot{
            width: 45px;
            text-align: center;
          }
          .location{
            font-size: 32px;
            color: #333333;
            height: 45px;
            /*line-height: 45px;*/
            @extend %flex-align-center;
            i{
              font-size: 32px;
              color: #999999;
            }
          }
          .time{
            font-size: 26px;
            color: #999999;
            @extend %flex-align-center;
            .text{
              padding: 5px 0 20px;
            }
            i{
              font-size: 20px;
              color: #dddddd;
            }
          }
        }
        .num{
          font-size: 36px;
          color: #333333;
          flex: 0 0 200px;
          align-self: flex-start;
          text-align: right;
          font-weight: bold;
        }
        &:last-child{
          border-bottom: none;
        }
      }
    }
    .no-data{
      padding: 60px 0;
      text-align: center;
      color: #858585;
      font-size: 26px;
    }
  }
  .bottom{
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 90px;
    line-height: 90px;
    font-size: 24px;
    text-align: center;
    color: #757575;
    background-color: #f5f5f5;
  }
}
</style>
